import {
  PROBATION_QUESTION_FETCHING,
  PROBATION_QUESTION_FAILED,
  PROBATION_QUESTION_SUCCESS,
} from "../actions/types";

const initialState = {
  result: null,
  isFetching: false,
  isError: false,
};

export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case PROBATION_QUESTION_FETCHING:
      return { ...state, result: null, isFetching: true, isError: false };
    case PROBATION_QUESTION_FAILED:
      return { ...state, result: null, isFetching: false, isError: true };
    case PROBATION_QUESTION_SUCCESS:
      return { ...state, result: payload, isFetching: false, isError: false };
    default:
      return state;
  }
}
